import SecondaryWalletTypeDepositInterestSettings from "@/models/Products/ProductSettings/SecondaryWallets/Savings/SecondaryWalletTypeDepositInterestSettings";

export default class UpdateSecondaryWalletInterestSettingsRequest extends SecondaryWalletTypeDepositInterestSettings {

    public constructor(secondaryWalletInterestSettings: SecondaryWalletTypeDepositInterestSettings) {
        super();
        this.overridden = true;
        this.enabled = secondaryWalletInterestSettings.enabled;
        this.overridable = secondaryWalletInterestSettings.overridable;
        this.rateType = secondaryWalletInterestSettings.rateType;
        this.rateValue = +secondaryWalletInterestSettings.rateValue;
        this.rateSourceId = secondaryWalletInterestSettings.rateSourceId;
        this.interestBearingThreshold.amount = secondaryWalletInterestSettings.interestBearingThreshold.amount;
        this.interestBearingThreshold.currency = secondaryWalletInterestSettings.interestBearingThreshold.currency;
    }
}